var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',{staticClass:"contact-tag"},[_c('a',{attrs:{"href":"mailto:hello@lucasmccallum.com"}},[_vm._v("hello@lucasmccallum.com")])]),_c('p',{staticClass:"contact-tag"},[_c('a',{attrs:{"href":"mailto:hello@lucasmccallum.com","target":"_blank"}},[_vm._v("LinkedIn")])])])
}]

export { render, staticRenderFns }